{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit libdatagrid;


interface

{$IFDEF PAS2JS}
{$mode objfpc}
{$modeswitch externalclass}
{$ENDIF}

uses
  WEBLib.DataGrid.Common,
  Web, JS, Classes, jsdelphisystem, DB;

type

  { TJSConvert }
  TJSConvert = class
    class function FieldToJSValue(Field: TField): TJSValue;
    class function JSValueToField(Value: TJSValue; Field: TField): Boolean;
  end;

  TJSCallback = function : TJSValue of object;
  TResizeImageCallback = function(FileObject: TJSValue) : TJSValue of object;
  TJSDataGridOptions = class (TJSObject)
  public

  end;

  TJSRowNode = class
  public
    RowIndex : Integer {$ifdef PAS2JS} external name 'rowIndex' {$endif};
    Id : String {$ifdef PAS2JS} external name 'id' {$endif};
    Data : TJSObject {$ifdef PAS2JS} external name 'data' {$endif};
    procedure SetSelected(newValue: Boolean) {$ifdef PAS2JS} external name 'setSelected' {$endif}; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function IsSelected(): Boolean {$ifdef PAS2JS} external name 'isSelected' {$endif}; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure SetData(newValue: TJSObject) {$ifdef PAS2JS} external name 'setData' {$endif}; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure SetDataValue(ColumnName: String; newValue: TJSValue) {$ifdef PAS2JS} external name 'setDataValue' {$endif}; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
  end;
  TJSRowNodes = array of TJSRowNode;

  TJSGetCellValueParams = class
  public
    RowNode: TJSRowNode {$ifdef PAS2JS} external name 'rowNode' {$endif};
    ColKey: String {$ifdef PAS2JS} external name 'colKey' {$endif};
    UseFormatter: Boolean {$ifdef PAS2JS} external name 'useFormatter' {$endif};
    constructor Create(ARowNode: TJSRowNode; AColKey: String; AUseFormatter: Boolean = True);
  end;

  TJSValueGetterParam = class
    Context : TJSObject {$ifdef PAS2JS} external name 'context' {$endif};
    Data : TJSObject {$ifdef PAS2JS} external name 'data' {$endif};
    Node : TJSRowNode {$ifdef PAS2JS} external name 'node' {$endif};
    ColDef : TJSObject {$ifdef PAS2JS} external name 'colDef' {$endif};
    Column : TJSObject {$ifdef PAS2JS} external name 'column' {$endif};
  end;

  TJSCellRendererParam = class
    Value : TJSValue {$ifdef PAS2JS} external name 'value' {$endif};
    ValueFormatted : String {$ifdef PAS2JS} external name 'valueFormatted' {$endif};
    FullWidth : Boolean {$ifdef PAS2JS} external name 'fullWidth' {$endif};
    Pinned : String {$ifdef PAS2JS} external name 'pinned' {$endif};
    Data : TJSObject {$ifdef PAS2JS} external name 'data' {$endif};
    Node : TJSRowNode {$ifdef PAS2JS} external name 'node' {$endif};
    ColDef : TJSObject {$ifdef PAS2JS} external name 'colDef' {$endif};
    Column : TJSObject {$ifdef PAS2JS} external name 'column' {$endif};
    EGridCell : TJSHTMLElement {$ifdef PAS2JS} external name 'eGridCell' {$endif};
    EParentOfValue : TJSHTMLElement {$ifdef PAS2JS} external name 'eParentOfValue' {$endif};
  end;

  TJSCellEditingColumnDef = class
    Field : String {$ifdef PAS2JS} external name 'field' {$endif};
    Editable : Boolean {$ifdef PAS2JS} external name 'editable' {$endif};
  end;
  TJSCellEditingColumn = class
    ColId : String {$ifdef PAS2JS} external name 'colId' {$endif};
    ColDef : TJSCellEditingColumnDef {$ifdef PAS2JS} external name 'colDef' {$endif};
  end;
  TJSCellEditingEvent = class
    Column : TJSCellEditingColumn {$ifdef PAS2JS} external name 'column' {$endif};
    RowIndex : Integer {$ifdef PAS2JS} external name 'rowIndex' {$endif};
    Data : TJSObject {$ifdef PAS2JS} external name 'data' {$endif};
    Node : TJSRowNode {$ifdef PAS2JS} external name 'node' {$endif};
    NewValue : TJSObject {$ifdef PAS2JS} external name 'newValue' {$endif};
    OldValue : TJSObject {$ifdef PAS2JS} external name 'oldValue' {$endif};
    ValueChanged : Boolean {$ifdef PAS2JS} external name 'valueChanged' {$endif};

  end;
  TJSRowEditingEvent = class
    RowIndex : Integer {$ifdef PAS2JS} external name 'rowIndex' {$endif};
    Data : TJSObject {$ifdef PAS2JS} external name 'data' {$endif};
    Node : TJSRowNode {$ifdef PAS2JS} external name 'node' {$endif};


  end;
  TJSPaginationChangedEvent = class
    Animate : TJSValue {$ifdef PAS2JS} external name 'animate' {$endif};
    KeepRenderedRows : TJSValue {$ifdef PAS2JS} external name 'keepRenderedRows' {$endif};
    NewData : TJSValue {$ifdef PAS2JS} external name 'newData' {$endif};
    NewPage : Boolean {$ifdef PAS2JS} external name 'newPage' {$endif};
    NewPageSize : TJSValue {$ifdef PAS2JS} external name 'newPageSize' {$endif};
  end;
  TJSSelectionChangedEvent = class
    Source : String {$ifdef PAS2JS} external name 'source' {$endif};
    Context : TJSObject {$ifdef PAS2JS} external name 'context' {$endif};
    Type_ : String {$ifdef PAS2JS} external name 'type' {$endif};
  end;
  TJSSortChangedEvent = class
    Source : String {$ifdef PAS2JS} external name 'source' {$endif};
    Column : TJSArray {$ifdef PAS2JS} external name 'column' {$endif};
    Context : TJSObject {$ifdef PAS2JS} external name 'context' {$endif};
    Type_ : String {$ifdef PAS2JS} external name 'type' {$endif};
  end;
  TJSFilterChangedEvent = class
    Source : String {$ifdef PAS2JS} external name 'source' {$endif};
    AfterDataChange : Boolean {$ifdef PAS2JS} external name 'afterDataChange' {$endif};
    AfterFloatingFilter : Boolean {$ifdef PAS2JS} external name 'afterFloatingFilter' {$endif};
    Column : TJSArray {$ifdef PAS2JS} external name 'column' {$endif};
    Context : TJSObject {$ifdef PAS2JS} external name 'context' {$endif};
    Type_ : String {$ifdef PAS2JS} external name 'type' {$endif};
  end;

  TJSGetRowStyleParams = class
    Context : TJSObject {$ifdef PAS2JS} external name 'context' {$endif};
    Data : TJSObject {$ifdef PAS2JS} external name 'data' {$endif};
    Node : TJSRowNode {$ifdef PAS2JS} external name 'node' {$endif};
    RowIndex : Integer {$ifdef PAS2JS} external name 'rowIndex' {$endif};
  end;
  TJSGetRowClassParams = class
    Context : TJSObject {$ifdef PAS2JS} external name 'context' {$endif};
    Data : TJSObject {$ifdef PAS2JS} external name 'data' {$endif};
    Node : TJSRowNode {$ifdef PAS2JS} external name 'node' {$endif};
    RowIndex : Integer {$ifdef PAS2JS} external name 'rowIndex' {$endif};
  end;

  TJSStartEditingCellParams = class
    RowIndex : Integer {$ifdef PAS2JS} external name 'rowIndex' {$endif};
    colKey : String {$ifdef PAS2JS} external name 'colKey' {$endif};
  end;

  TJSFocusedCell = class
    Column : TJSCellEditingColumn {$ifdef PAS2JS} external name 'column' {$endif};
  end;

  TJSCellPosition = class
    Column : TJSCellEditingColumn {$ifdef PAS2JS} external name 'column' {$endif};
    RowIndex : Integer {$ifdef PAS2JS} external name 'rowIndex' {$endif};
    RowPinned : TJSValue {$ifdef PAS2JS} external name 'rowPinned' {$endif};
  end;
  TJSCellPositions = array of TJSCellPosition;

  TJSRowSelectedEvent = class
    Node : TJSRowNode {$ifdef PAS2JS} external name 'node' {$endif};
    Source : String {$ifdef PAS2JS} external name 'source' {$endif};
  end;

  TJSTabToNextCellParams = class
    Backwards: Boolean {$ifdef PAS2JS} external name 'backwards' {$endif};
    Editing: Boolean {$ifdef PAS2JS} external name 'editing' {$endif};
    PreviousCellPosition: TJSCellPosition {$ifdef PAS2JS} external name 'previousCellPosition' {$endif};
    NextCellPosition: TJSCellPosition {$ifdef PAS2JS} external name 'nextCellPosition' {$endif};
  end;

  TJSColumnStateParams = class
    Hide: Boolean {$ifdef PAS2JS} external name 'hide' {$endif};
    Width: Integer {$ifdef PAS2JS} external name 'width' {$endif};
    Flex: Integer {$ifdef PAS2JS} external name 'flex' {$endif};
    Sort: String {$ifdef PAS2JS} external name 'sort' {$endif};
    SortIndex: Integer {$ifdef PAS2JS} external name 'sortIndex' {$endif};
    AggFunc: String {$ifdef PAS2JS} external name 'aggFunc' {$endif};
    Pivot: Boolean {$ifdef PAS2JS} external name 'pivot' {$endif};
    PivotIndex: Integer {$ifdef PAS2JS} external name 'pivotIndex' {$endif};
    Pinned: TJSValue {$ifdef PAS2JS} external name 'pinned' {$endif};
    RowGroup: Boolean {$ifdef PAS2JS} external name 'rowGroup' {$endif};
    RowGroupIndex: Integer {$ifdef PAS2JS} external name 'rowGroupIndex' {$endif};
  end;
  TJSColumnState = class(TJSColumnStateParams)
    ColId: string {$ifdef PAS2JS} external name 'colId' {$endif};
//AC:    Sort: TJSValue  {$ifdef PAS2JS} external name 'sort' {$endif};
//AC:    SortIndex: TJSValue {$ifdef PAS2JS} external name 'sortIndex' {$endif};
  end;
  TJSColumnStates = array of TJSColumnState;
  TJSApplyColumnStateParams = class
    State: TJSColumnStates {$ifdef PAS2JS} external name 'state' {$endif};
    ApplyOrder: Boolean {$ifdef PAS2JS} external name 'applyOrder' {$endif};
    DefaultState: Boolean {$ifdef PAS2JS} external name 'defaultState' {$endif};
  end;


  TJSRowNodeTransaction = class
    Add : TJSRowNodes {$ifdef PAS2JS} external name 'add' {$endif};
    Remove : TJSRowNodes {$ifdef PAS2JS} external name 'remove' {$endif};
    Update : TJSRowNodes {$ifdef PAS2JS} external name 'update' {$endif};
  end;

  TJSRowHeightParams = class
    Data : TJSObject {$ifdef PAS2JS} external name 'data' {$endif};
    Node : TJSRowNode {$ifdef PAS2JS} external name 'node' {$endif};
  end;

  TJSSuccessCallback = procedure(rowsThisBlock: TJSArray; lastRow: Integer) of object;
  TJSFailCallback = procedure of object;
  TJSSortModelItem = class
    ColId: string {$ifdef PAS2JS} external name 'colId' {$endif};
    Sort: string {$ifdef PAS2JS} external name 'sort' {$endif}; // 'asc' | 'desc';
  end;
  TJSSortModelItems = array of TJSSortModelItem;
  TJSGetRowsParams = class
    StartRow: Integer {$ifdef PAS2JS} external name 'startRow' {$endif};
    EndRow: Integer {$ifdef PAS2JS} external name 'endRow' {$endif};
    SuccessCallback: TJSSuccessCallback {$ifdef PAS2JS} external name 'successCallback' {$endif};
    FailCallback: TJSFailCallback {$ifdef PAS2JS} external name 'failCallback' {$endif};
    SortModel: TJSSortModelItems {$ifdef PAS2JS} external name 'sortModel' {$endif};
    FilterModel: TJSObject {$ifdef PAS2JS} external name 'filterModel' {$endif};
    Context: TJSValue {$ifdef PAS2JS} external name 'context' {$endif};
  end;
  TJSGetRowsCallback = procedure(Params: TJSGetRowsParams) of object;
  TJSDataSource = class
    RowCount: TJSValue {$ifdef PAS2JS} external name 'rowCount' {$endif};
    GetRows: TJSGetRowsCallback {$ifdef PAS2JS} external name 'getRows' {$endif};
    Destroy_: TJSFunction {$ifdef PAS2JS} external name 'destroy' {$endif};
  end;


  TJSFilterCondition = class
  public
    FilterType: String {$ifdef PAS2JS} external name 'filterType' {$endif};
    Type_: String {$ifdef PAS2JS} external name 'type' {$endif};
    Filter: String {$ifdef PAS2JS} external name 'filter' {$endif};
    FilterTo: String {$ifdef PAS2JS} external name 'filterTo' {$endif};
    DateFrom: String {$ifdef PAS2JS} external name 'dateFrom' {$endif};
    DateTo: String {$ifdef PAS2JS} external name 'dateTo' {$endif};
  end;
  TJSFilterConditions = class
  public
    Conditions: TJSArray {$ifdef PAS2JS} external name 'conditions' {$endif};
    FilterType: String {$ifdef PAS2JS} external name 'filterType' {$endif};
    Operator_: String {$ifdef PAS2JS} external name 'operator' {$endif};
  end;

  TJSGetLocaleTextParams = class
  public
    Key: String {$ifdef PAS2JS} external name 'key' {$endif};
    DefaultValue: String {$ifdef PAS2JS} external name 'defaultValue' {$endif};
    VariableValues: TJSArray {$ifdef PAS2JS} external name 'variableValues' {$endif}; // string[]
  end;

{$REGION 'ColDefs'}
  TJSColDef = class
  public
    ColId: String {$ifdef PAS2JS} external name 'colId' {$endif};
    Field: TJSValue {$ifdef PAS2JS} external name 'field' {$endif};
    Type_: TJSValue {$ifdef PAS2JS} external name 'type' {$endif};
    CellDataType: TJSValue {$ifdef PAS2JS} external name 'cellDataType' {$endif};
    ValueGetter: TJSValue {$ifdef PAS2JS} external name 'valueGetter' {$endif};
  end;
  TJSCellClassParams = class
  public
    Column: TJSObject {$ifdef PAS2JS} external name 'column' {$endif};
    ColDef: TJSColDef {$ifdef PAS2JS} external name 'colDef' {$endif};
    Value: TJSValue {$ifdef PAS2JS} external name 'value' {$endif};
  end;
{$ENDREGION}

{$REGION 'Compatibility Types'}
  TJSAgGrid = class;
  TJSGridApi = TJSAgGrid;
  TJSTContext = TJSValue;
  TJSTEventType = String;
  TJSRowPinnedType = TJSValue;
  TJSColumnEventType = TJSValue;
  TJSGridOptions = TJSObject;
  TJSSelectionEventSourceType = String;
  TJSColumn = TJSObject;
  TJSIFilterComp = TJSValue;
  TJSFilterRequestSource = TJSValue;
  TJSGridState = TJSValue;
  TJSCellRange = TJSValue;
  TJSCellRangeParams = TJSValue;
  TJSChartType = TJSValue;
  TJSAgChartThemeOverrides = TJSValue;
  ProvidedColumnGroup = TJSValue;
  TJSScrollDirection = TJSValue;
  TJSColumnPinnedType = TJSValue;
//  TJSColDef = TJSObject;
  TJSTData = TJSValue;

  TJSExpandOrCollapseAllEvent = class;
{$ENDREGION}

{$REGION 'AG-Grid Events'}
{$REGION 'Code'}
TJSAgGridCommon = class  // (Line #163)
  Api : TJSGridApi {$IFDEF PAS2JS} external name 'api' {$ENDIF};
  Context : TJSTContext {$IFDEF PAS2JS} external name 'context' {$ENDIF};
end;

TJSAgEvent = class  // (Line #170)
  Type_ : TJSTEventType {$IFDEF PAS2JS} external name 'type' {$ENDIF};
end;

TJSAgGridEvent = class(TJSAgGridCommon (* , TJSAgEvent *))  // (Line #175)
  Type_ : TJSTEventType {$IFDEF PAS2JS} external name 'type' {$ENDIF};
end;

TJSAgGlobalEvent = class(TJSAgGridEvent)  // (Line #179)
end;

TJSModelUpdatedEvent = class(TJSAgGlobalEvent)  // (Line #191)
  Animate : TJSValue {$IFDEF PAS2JS} external name 'animate' {$ENDIF}; (* Union Type(2): boolean | undefined *)
  KeepRenderedRows : TJSValue {$IFDEF PAS2JS} external name 'keepRenderedRows' {$ENDIF}; (* Union Type(2): boolean | undefined *)
  NewData : TJSValue {$IFDEF PAS2JS} external name 'newData' {$ENDIF}; (* Union Type(2): boolean | undefined *)
  NewPage : Boolean {$IFDEF PAS2JS} external name 'newPage' {$ENDIF};
  NewPageSize : TJSValue {$IFDEF PAS2JS} external name 'newPageSize' {$ENDIF}; (* boolean *)
  KeepUndoRedoStack : TJSValue {$IFDEF PAS2JS} external name 'keepUndoRedoStack' {$ENDIF}; (* boolean *)
end;

//TJSPaginationChangedEvent = class(TJSAgGlobalEvent)  // (Line #209)
//  Animate : TJSValue {$IFDEF PAS2JS} external name 'animate' {$ENDIF}; (* boolean *)
//  KeepRenderedRows : TJSValue {$IFDEF PAS2JS} external name 'keepRenderedRows' {$ENDIF}; (* boolean *)
//  NewData : TJSValue {$IFDEF PAS2JS} external name 'newData' {$ENDIF}; (* boolean *)
//  NewPage : Boolean {$IFDEF PAS2JS} external name 'newPage' {$ENDIF};
//  NewPageSize : TJSValue {$IFDEF PAS2JS} external name 'newPageSize' {$ENDIF}; (* boolean *)
//end;

TJSToolPanelSizeChangedEvent = class(TJSAgGlobalEvent)  // (Line #223)
  Started : Boolean {$IFDEF PAS2JS} external name 'started' {$ENDIF};
  Ended : Boolean {$IFDEF PAS2JS} external name 'ended' {$ENDIF};
  Width : Integer {$IFDEF PAS2JS} external name 'width' {$ENDIF};
end;

TJSColumnPivotModeChangedEvent = class(TJSAgGlobalEvent)  // (Line #233)
end;

TJSVirtualColumnsChangedEvent = class(TJSAgGlobalEvent)  // (Line #236)
  AfterScroll : Boolean {$IFDEF PAS2JS} external name 'afterScroll' {$ENDIF};
end;

TJSColumnEverythingChangedEvent = class(TJSAgGlobalEvent)  // (Line #241)
  Source : String {$IFDEF PAS2JS} external name 'source' {$ENDIF};
end;

TJSNewColumnsLoadedEvent = class(TJSAgGlobalEvent)  // (Line #246)
  Source : TJSColumnEventType {$IFDEF PAS2JS} external name 'source' {$ENDIF};
end;

TJSGridColumnsChangedEvent = class(TJSAgGlobalEvent)  // (Line #251)
end;

TJSDisplayedColumnsChangedEvent = class(TJSAgGlobalEvent)  // (Line #254)
end;

TJSRowDataUpdatedEvent = class(TJSAgGlobalEvent)  // (Line #257)
end;

TJSRowDataUpdateStartedEvent = class(TJSAgGlobalEvent)  // (Line #260)
  FirstRowData : TJSValue {$IFDEF PAS2JS} external name 'firstRowData' {$ENDIF}; (* Union Type(2): TData | null *)
end;

TJSPinnedRowDataChangedEvent = class(TJSAgGlobalEvent)  // (Line #265)
end;

TJSPinnedHeightChangedEvent = class(TJSAgGlobalEvent)  // (Line #267)
end;

//TJSSelectionChangedEvent = class(TJSAgGlobalEvent)  // (Line #329)
//  Source : TJSSelectionEventSourceType {$IFDEF PAS2JS} external name 'source' {$ENDIF};
//end;

//TJSFilterChangedEvent = class(TJSAgGlobalEvent)  // (Line #336)
//  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* TJSFilterChangedEventSourceType *)
//  AfterDataChange : TJSValue {$IFDEF PAS2JS} external name 'afterDataChange' {$ENDIF}; (* boolean *)
//  AfterFloatingFilter : TJSValue {$IFDEF PAS2JS} external name 'afterFloatingFilter' {$ENDIF}; (* boolean *)
//  Columns : Array of TJSColumn {$IFDEF PAS2JS} external name 'columns' {$ENDIF};
//end;

TJSFilterModifiedEvent = class(TJSAgGlobalEvent)  // (Line #361)
  FilterInstance : TJSIFilterComp {$IFDEF PAS2JS} external name 'filterInstance' {$ENDIF};
  Column : TJSColumn {$IFDEF PAS2JS} external name 'column' {$ENDIF};
end;

TJSFilterOpenedEvent = class(TJSAgGlobalEvent)  // (Line #367)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | ProvidedColumnGroup *)
  Source : TJSFilterRequestSource {$IFDEF PAS2JS} external name 'source' {$ENDIF};
  EGui : TJSHTMLElement {$IFDEF PAS2JS} external name 'eGui' {$ENDIF};
end;

TJSFilterDestroyedEvent = class(TJSAgGlobalEvent)  // (Line #377)
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(5): 'api' | 'columnChanged' | 'gridDestroyed' | 'advancedFilterEnabled' | 'paramsUpdated' *)
  Column : TJSColumn {$IFDEF PAS2JS} external name 'column' {$ENDIF};
end;

//TJSSortChangedEvent = class(TJSAgGlobalEvent)  // (Line #383)
//  Source : String {$IFDEF PAS2JS} external name 'source' {$ENDIF};
//  Columns : TJSValue {$IFDEF PAS2JS} external name 'columns' {$ENDIF}; (* array of Column *)
//end;

TJSGridReadyEvent = class(TJSAgGlobalEvent)  // (Line #392)
end;

TJSGridPreDestroyedEvent = class(TJSAgGlobalEvent)  // (Line #393)
  State : TJSGridState {$IFDEF PAS2JS} external name 'state' {$ENDIF};
end;

TJSColumnContainerWidthChanged = class(TJSAgGlobalEvent)  // (Line #399)
end;

TJSDisplayedColumnsWidthChangedEvent = class(TJSAgGlobalEvent)  // (Line #401)
end;

TJSColumnHoverChangedEvent = class(TJSAgGlobalEvent)  // (Line #403)
end;

TJSBodyHeightChangedEvent = class(TJSAgGlobalEvent)  // (Line #405)
end;

TJSComponentStateChangedEvent = class(TJSAgGlobalEvent)  // (Line #412)
end;

TJSColumnPanelItemDragStartEvent = class(TJSAgGlobalEvent)  // (Line #415)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | ProvidedColumnGroup *)
end;

TJSColumnPanelItemDragEndEvent = class(TJSAgGlobalEvent)  // (Line #420)
end;

TJSAgDragEvent = class(TJSAgGlobalEvent)  // (Line #423)
  Target : TJSElement {$IFDEF PAS2JS} external name 'target' {$ENDIF};
end;

TJSDragStartedEvent = class(TJSAgDragEvent)  // (Line #429)
//  Type_ : String (* 'dragStarted' *) {$IFDEF PAS2JS} external name 'type' {$ENDIF};
end;

TJSDragStoppedEvent = class(TJSAgDragEvent)  // (Line #433)
//  Type_ : String (* 'dragStopped' *) {$IFDEF PAS2JS} external name 'type' {$ENDIF};
end;

TJSCheckboxChangedEvent = class(TJSAgGlobalEvent)  // (Line #440)
  Id : String {$IFDEF PAS2JS} external name 'id' {$ENDIF};
  Name : String {$IFDEF PAS2JS} external name 'name' {$ENDIF};
  Selected : TJSValue {$IFDEF PAS2JS} external name 'selected' {$ENDIF}; (* boolean *)
  PreviousValue : TJSValue {$IFDEF PAS2JS} external name 'previousValue' {$ENDIF}; (* Union Type(2): boolean | undefined *)
end;

TJSGridSizeChangedEvent = class(TJSAgGlobalEvent)  // (Line #448)
  ClientWidth : Integer {$IFDEF PAS2JS} external name 'clientWidth' {$ENDIF};
  ClientHeight : Integer {$IFDEF PAS2JS} external name 'clientHeight' {$ENDIF};
end;

TJSPivotMaxColumnsExceededEvent = class(TJSAgGlobalEvent)  // (Line #456)
  Message : String {$IFDEF PAS2JS} external name 'message' {$ENDIF};
end;

TJSRowDragEvent = class(TJSAgGlobalEvent)  // (Line #461)
  Node : TJSRowNode {$IFDEF PAS2JS} external name 'node' {$ENDIF};
  Nodes : Array of TJSRowNode {$IFDEF PAS2JS} external name 'nodes' {$ENDIF};
  Event : TJSMouseEvent {$IFDEF PAS2JS} external name 'event' {$ENDIF};
  EventPath : TJSValue {$IFDEF PAS2JS} external name 'eventPath' {$ENDIF}; (* array of EventTarget *)
  VDirection : String {$IFDEF PAS2JS} external name 'vDirection' {$ENDIF};
  OverIndex : Integer {$IFDEF PAS2JS} external name 'overIndex' {$ENDIF};
  OverNode : TJSValue {$IFDEF PAS2JS} external name 'overNode' {$ENDIF}; (* TJSIRowNode *)
  Y : Integer {$IFDEF PAS2JS} external name 'y' {$ENDIF};
end;

TJSRowDragEnterEvent = class(TJSRowDragEvent)  // (Line #485)
end;

TJSRowDragEndEvent = class(TJSRowDragEvent)  // (Line #487)
end;

TJSRowDragMoveEvent = class(TJSRowDragEvent)  // (Line #489)
end;

TJSRowDragLeaveEvent = class(TJSRowDragEvent)  // (Line #491)
end;

TJSCutStartEvent = class(TJSAgGlobalEvent)  // (Line #493)
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(3): 'api' | 'ui' | 'contextMenu' *)
end;

TJSCutEndEvent = class(TJSAgGlobalEvent)  // (Line #497)
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(3): 'api' | 'ui' | 'contextMenu' *)
end;

TJSPasteStartEvent = class(TJSAgGlobalEvent)  // (Line #501)
  Source : String {$IFDEF PAS2JS} external name 'source' {$ENDIF};
end;

TJSPasteEndEvent = class(TJSAgGlobalEvent)  // (Line #505)
  Source : String {$IFDEF PAS2JS} external name 'source' {$ENDIF};
end;

TJSFillStartEvent = class(TJSAgGlobalEvent)  // (Line #509)
end;

TJSFillEndEvent = class(TJSAgGlobalEvent)  // (Line #511)
  InitialRange : TJSCellRange {$IFDEF PAS2JS} external name 'initialRange' {$ENDIF};
  FinalRange : TJSCellRange {$IFDEF PAS2JS} external name 'finalRange' {$ENDIF};
end;

TJSRangeDeleteStartEvent = class(TJSAgGlobalEvent)  // (Line #516)
  Source : String (* 'deleteKey' *) {$IFDEF PAS2JS} external name 'source' {$ENDIF};
end;

TJSRangeDeleteEndEvent = class(TJSAgGlobalEvent)  // (Line #521)
  Source : String (* 'deleteKey' *) {$IFDEF PAS2JS} external name 'source' {$ENDIF};
end;

TJSUndoStartedEvent = class(TJSAgGlobalEvent)  // (Line #526)
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(2): 'api' | 'ui' *)
end;

TJSUndoEndedEvent = class(TJSAgGlobalEvent)  // (Line #531)
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(2): 'api' | 'ui' *)
  OperationPerformed : Boolean {$IFDEF PAS2JS} external name 'operationPerformed' {$ENDIF};
end;

TJSRedoStartedEvent = class(TJSAgGlobalEvent)  // (Line #538)
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(2): 'api' | 'ui' *)
end;

TJSRedoEndedEvent = class(TJSAgGlobalEvent)  // (Line #543)
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(2): 'api' | 'ui' *)
  OperationPerformed : Boolean {$IFDEF PAS2JS} external name 'operationPerformed' {$ENDIF};
end;

TJSViewportChangedEvent = class(TJSAgGlobalEvent)  // (Line #550)
  FirstRow : Integer {$IFDEF PAS2JS} external name 'firstRow' {$ENDIF};
  LastRow : Integer {$IFDEF PAS2JS} external name 'lastRow' {$ENDIF};
end;

TJSFirstDataRenderedEvent = class(TJSAgGlobalEvent)  // (Line #558)
  FirstRow : Integer {$IFDEF PAS2JS} external name 'firstRow' {$ENDIF};
  LastRow : Integer {$IFDEF PAS2JS} external name 'lastRow' {$ENDIF};
end;

TJSRangeSelectionChangedEvent = class(TJSAgGlobalEvent)  // (Line #566)
  Id : TJSValue {$IFDEF PAS2JS} external name 'id' {$ENDIF}; (* string *)
  Started : Boolean {$IFDEF PAS2JS} external name 'started' {$ENDIF};
  Finished : Boolean {$IFDEF PAS2JS} external name 'finished' {$ENDIF};
end;

TJSChartCreatedEvent = class(TJSAgGlobalEvent)  // (Line #575)
  ChartId : String {$IFDEF PAS2JS} external name 'chartId' {$ENDIF};
end;

TJSChartCreated = class(TJSChartCreatedEvent)  // (deprecated) (Line #580)
end;

TJSChartRangeSelectionChangedEvent = class(TJSAgGlobalEvent)  // (deprecated) (Line #582)
  ChartId : String {$IFDEF PAS2JS} external name 'chartId' {$ENDIF};
  Id : String {$IFDEF PAS2JS} external name 'id' {$ENDIF};
  CellRange : TJSCellRangeParams {$IFDEF PAS2JS} external name 'cellRange' {$ENDIF};
end;

TJSChartRangeSelectionChanged = class(TJSChartRangeSelectionChangedEvent)  // (deprecated) (Line #592)
end;

TJSChartOptionsChangedEvent = class(TJSAgGlobalEvent)  // (deprecated) (Line #595)
  ChartId : String {$IFDEF PAS2JS} external name 'chartId' {$ENDIF};
  ChartType : TJSChartType {$IFDEF PAS2JS} external name 'chartType' {$ENDIF};
  ChartThemeName : String {$IFDEF PAS2JS} external name 'chartThemeName' {$ENDIF};
  ChartOptions : TJSAgChartThemeOverrides {$IFDEF PAS2JS} external name 'chartOptions' {$ENDIF};
end;

TJSChartOptionsChanged = class(TJSChartOptionsChangedEvent)  // (deprecated) (Line #607)
end;

TJSChartDestroyedEvent = class(TJSAgGlobalEvent)  // (deprecated) (Line #609)
  ChartId : String {$IFDEF PAS2JS} external name 'chartId' {$ENDIF};
end;

TJSChartDestroyed = class(TJSChartDestroyedEvent)  // (deprecated) (Line #616)
end;

TJSColumnGroupOpenedEvent = class(TJSAgGlobalEvent)  // (deprecated) (Line #618)
  ColumnGroup : TJSValue {$IFDEF PAS2JS} external name 'columnGroup' {$ENDIF}; (* TJSProvidedColumnGroup *)
  ColumnGroups : Array of ProvidedColumnGroup {$IFDEF PAS2JS} external name 'columnGroups' {$ENDIF};
end;

TJSBaseBodyScrollEvent = class(TJSAgGlobalEvent)  // (Line #626)
  Direction : TJSScrollDirection {$IFDEF PAS2JS} external name 'direction' {$ENDIF};
  Left : Integer {$IFDEF PAS2JS} external name 'left' {$ENDIF};
  Top : Integer {$IFDEF PAS2JS} external name 'top' {$ENDIF};
end;

TJSBodyScrollEvent = class(TJSBaseBodyScrollEvent)  // (Line #632)
end;

TJSBodyScrollEndEvent = class(TJSBaseBodyScrollEvent)  // (Line #635)
end;

TJSTooltipEvent = class(TJSAgGlobalEvent)  // (Line #638)
  ParentGui : TJSHTMLElement {$IFDEF PAS2JS} external name 'parentGui' {$ENDIF};
end;

TJSTooltipShowEvent = class(TJSTooltipEvent)  // (Line #642)
  TooltipGui : TJSHTMLElement {$IFDEF PAS2JS} external name 'tooltipGui' {$ENDIF};
end;

TJSTooltipHideEvent = class(TJSTooltipEvent)  // (Line #646)
end;

TJSPaginationPixelOffsetChangedEvent = class(TJSAgGlobalEvent)  // (Line #648)
end;

TJSStickyTopOffsetChangedEvent = class(TJSAgEvent (* , TJSAgGlobalEvent *))  // (Line #1119)
  Offset : Integer {$IFDEF PAS2JS} external name 'offset' {$ENDIF};
end;

TJSCommonCellFocusParams = class  // (Line #655)
  RowIndex : TJSValue {$IFDEF PAS2JS} external name 'rowIndex' {$ENDIF}; (* Union Type(2): number | null *)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(3): Column | string | null *)
  RowPinned : TJSRowPinnedType {$IFDEF PAS2JS} external name 'rowPinned' {$ENDIF};
  IsFullWidthCell : TJSValue {$IFDEF PAS2JS} external name 'isFullWidthCell' {$ENDIF}; (* boolean *)
end;

TJSCellFocusClearedParams = class(TJSCommonCellFocusParams)  // (Line #666)
end;

TJSCellFocusedParams = class(TJSCommonCellFocusParams)  // (Line #668)
  ForceBrowserFocus : TJSValue {$IFDEF PAS2JS} external name 'forceBrowserFocus' {$ENDIF}; (* boolean *)
  PreventScrollOnBrowserFocus : TJSValue {$IFDEF PAS2JS} external name 'preventScrollOnBrowserFocus' {$ENDIF}; (* boolean *)
end;

TJSHeaderFocusedParams = class  // (Line #675)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | ColumnGroup *)
end;

TJSHeaderFocusedEvent = class(TJSAgGlobalEvent (* , TJSHeaderFocusedParams *))  // (Line #679)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | ColumnGroup *)
end;

TJSCellFocusClearedEvent = class(TJSAgGlobalEvent (* , TJSCellFocusClearedParams *))  // (Line #683)
  RowIndex : TJSValue {$IFDEF PAS2JS} external name 'rowIndex' {$ENDIF}; (* Union Type(2): number | null *)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(3): Column | string | null *)
  RowPinned : TJSRowPinnedType {$IFDEF PAS2JS} external name 'rowPinned' {$ENDIF};
  IsFullWidthCell : TJSValue {$IFDEF PAS2JS} external name 'isFullWidthCell' {$ENDIF}; (* boolean *)
end;

TJSCellFocusedEvent = class(TJSAgGlobalEvent (* , TJSCellFocusedParams *))  // (Line #689)
  ForceBrowserFocus : TJSValue {$IFDEF PAS2JS} external name 'forceBrowserFocus' {$ENDIF}; (* boolean *)
  PreventScrollOnBrowserFocus : TJSValue {$IFDEF PAS2JS} external name 'preventScrollOnBrowserFocus' {$ENDIF}; (* boolean *)
  RowIndex : TJSValue {$IFDEF PAS2JS} external name 'rowIndex' {$ENDIF}; (* Union Type(2): number | null *)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(3): Column | string | null *)
  RowPinned : TJSRowPinnedType {$IFDEF PAS2JS} external name 'rowPinned' {$ENDIF};
  IsFullWidthCell : TJSValue {$IFDEF PAS2JS} external name 'isFullWidthCell' {$ENDIF}; (* boolean *)
end;

TJSFullWidthRowFocusedEvent = class(TJSAgGlobalEvent (* , TJSCellFocusedParams *))  // (Line #693)
  FromBelow : Boolean {$IFDEF PAS2JS} external name 'fromBelow' {$ENDIF};
  ForceBrowserFocus : TJSValue {$IFDEF PAS2JS} external name 'forceBrowserFocus' {$ENDIF}; (* boolean *)
  PreventScrollOnBrowserFocus : TJSValue {$IFDEF PAS2JS} external name 'preventScrollOnBrowserFocus' {$ENDIF}; (* boolean *)
  RowIndex : TJSValue {$IFDEF PAS2JS} external name 'rowIndex' {$ENDIF}; (* Union Type(2): number | null *)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(3): Column | string | null *)
  RowPinned : TJSRowPinnedType {$IFDEF PAS2JS} external name 'rowPinned' {$ENDIF};
  IsFullWidthCell : TJSValue {$IFDEF PAS2JS} external name 'isFullWidthCell' {$ENDIF}; (* boolean *)
end;

TJSExpandOrCollapseAllEvent = class(TJSAgGlobalEvent)  // (deprecated) (Line #704)
  Source : String {$IFDEF PAS2JS} external name 'source' {$ENDIF};
end;

TJSExpandCollapseAllEvent = class(TJSExpandOrCollapseAllEvent)  // (deprecated) (Line #702)
end;

TJSColumnEvent = class(TJSAgGridEvent)  // (Line #740)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | null *)
  Columns : TJSValue {$IFDEF PAS2JS} external name 'columns' {$ENDIF};
  Source : TJSColumnEventType {$IFDEF PAS2JS} external name 'source' {$ENDIF};
end;

TJSColumnResizedEvent = class(TJSColumnEvent)  // (Line #750)
  Finished : Boolean {$IFDEF PAS2JS} external name 'finished' {$ENDIF};
  FlexColumns : TJSValue {$IFDEF PAS2JS} external name 'flexColumns' {$ENDIF};
end;

TJSColumnPivotChangedEvent = class(TJSColumnEvent)  // (Line #757)
end;

TJSColumnRowGroupChangedEvent = class(TJSColumnEvent)  // (Line #760)
end;

TJSColumnValueChangedEvent = class(TJSColumnEvent)  // (Line #763)
end;

TJSColumnMovedEvent = class(TJSColumnEvent)  // (Line #766)
  ToIndex : TJSValue {$IFDEF PAS2JS} external name 'toIndex' {$ENDIF}; (* number *)
  Finished : Boolean {$IFDEF PAS2JS} external name 'finished' {$ENDIF};
end;

TJSColumnVisibleEvent = class(TJSColumnEvent)  // (Line #773)
  Visible : TJSValue {$IFDEF PAS2JS} external name 'visible' {$ENDIF}; (* boolean *)
end;

TJSColumnPinnedEvent = class(TJSColumnEvent)  // (Line #778)
  Pinned : TJSColumnPinnedType {$IFDEF PAS2JS} external name 'pinned' {$ENDIF};
end;

TJSColumnHeaderMouseOverEvent = class(TJSAgGlobalEvent)  // (Line #783)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | ProvidedColumnGroup *)
end;

TJSColumnHeaderMouseLeaveEvent = class(TJSAgGlobalEvent)  // (Line #789)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | ProvidedColumnGroup *)
end;

TJSColumnHeaderClickedEvent = class(TJSAgGlobalEvent)  // (Line #795)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | ProvidedColumnGroup *)
end;

TJSColumnHeaderContextMenuEvent = class(TJSAgGlobalEvent)  // (Line #801)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | ProvidedColumnGroup *)
end;

TJSContextMenuVisibleChangedEvent = class(TJSAgGlobalEvent)  // (Line #810)
  Visible : Boolean {$IFDEF PAS2JS} external name 'visible' {$ENDIF};
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(2): 'api' | 'ui' *)
end;

TJSAdvancedFilterBuilderVisibleChangedEvent = class(TJSAgGlobalEvent)  // (Line #818)
  Visible : Boolean {$IFDEF PAS2JS} external name 'visible' {$ENDIF};
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(2): 'api' | 'ui' *)
end;

TJSToolPanelVisibleChangedEvent = class(TJSAgGlobalEvent)  // (Line #826)
  Visible : Boolean {$IFDEF PAS2JS} external name 'visible' {$ENDIF};
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(3): 'sideBarButtonClicked' | 'sideBarInitializing' | 'api' *)
  Key : String {$IFDEF PAS2JS} external name 'key' {$ENDIF};
  SwitchingToolPanel : Boolean {$IFDEF PAS2JS} external name 'switchingToolPanel' {$ENDIF};
end;

TJSColumnMenuVisibleChangedEvent = class(TJSAgGlobalEvent)  // (Line #837)
  Visible : Boolean {$IFDEF PAS2JS} external name 'visible' {$ENDIF};
  SwitchingTab : Boolean {$IFDEF PAS2JS} external name 'switchingTab' {$ENDIF};
  Key : TJSValue {$IFDEF PAS2JS} external name 'key' {$ENDIF}; (* Union Type(7): 'generalMenuTab' | 'filterMenuTab' | 'columnsMenuTab' | 'columnMenu' | 'columnFilter' | 'floatingFilter' | 'columnChooser' *)
  Column : TJSValue {$IFDEF PAS2JS} external name 'column' {$ENDIF}; (* Union Type(2): Column | null *)
end;

TJSBaseRowEvent = class(TJSAgGlobalEvent)  // (Line #870)
  Node : TJSRowNode {$IFDEF PAS2JS} external name 'node' {$ENDIF};
  RowIndex : TJSValue {$IFDEF PAS2JS} external name 'rowIndex' {$ENDIF}; (* Union Type(2): number | null *)
  RowPinned : TJSRowPinnedType {$IFDEF PAS2JS} external name 'rowPinned' {$ENDIF};
  Event : TJSValue {$IFDEF PAS2JS} external name 'event' {$ENDIF}; (* Union Type(2): Event | null *)
  EventPath : TJSValue {$IFDEF PAS2JS} external name 'eventPath' {$ENDIF}; (* array of EventTarget *)
end;

TJSRowEvent = class(TJSBaseRowEvent)  // (Line #883)
  Data : TJSValue {$IFDEF PAS2JS} external name 'data' {$ENDIF}; (* Union Type(2): TData | undefined *)
end;

TJSRowWithDataEvent = class(TJSBaseRowEvent)  // (Line #889)
  Data : TJSTData {$IFDEF PAS2JS} external name 'data' {$ENDIF};
end;

TJSRowGroupOpenedEvent = class(TJSRowEvent)  // (Line #895)
  Expanded : Boolean {$IFDEF PAS2JS} external name 'expanded' {$ENDIF};
end;

TJSRowValueChangedEvent = class(TJSRowEvent)  // (Line #900)
end;

//TJSRowSelectedEvent = class(TJSRowEvent)  // (Line #903)
//  Source : TJSSelectionEventSourceType {$IFDEF PAS2JS} external name 'source' {$ENDIF};
//end;

TJSVirtualRowRemovedEvent = class(TJSRowEvent)  // (Line #907)
end;

TJSRowClickedEvent = class(TJSRowEvent)  // (Line #910)
end;

TJSRowDoubleClickedEvent = class(TJSRowEvent)  // (Line #912)
end;

TJSRowEditingStartedEvent = class(TJSRowEvent)  // (Line #915)
end;

TJSRowEditingStoppedEvent = class(TJSRowEvent)  // (Line #918)
end;

TJSFullWidthCellKeyDownEvent = class(TJSRowEvent)  // (Line #921)
end;

TJSCellEvent = class(TJSRowEvent)  // (Line #928)
  Column : TJSColumn {$IFDEF PAS2JS} external name 'column' {$ENDIF};
  ColDef : TJSColDef {$IFDEF PAS2JS} external name 'colDef' {$ENDIF};
  Value : TJSValue {$IFDEF PAS2JS} external name 'value' {$ENDIF}; (* Union Type(3): TValue | null | undefined *)
end;

TJSCellWithDataEvent = class(TJSRowWithDataEvent)  // (Line #936)
  Column : TJSColumn {$IFDEF PAS2JS} external name 'column' {$ENDIF};
  ColDef : TJSColDef {$IFDEF PAS2JS} external name 'colDef' {$ENDIF};
  Value : TJSValue {$IFDEF PAS2JS} external name 'value' {$ENDIF}; (* Union Type(3): TValue | null | undefined *)
end;

TJSCellKeyDownEvent = class(TJSCellEvent)  // (Line #943)
end;

TJSCellClickedEvent = class(TJSCellEvent)  // (Line #945)
end;

TJSCellMouseDownEvent = class(TJSCellEvent)  // (Line #947)
end;

TJSCellDoubleClickedEvent = class(TJSCellEvent)  // (Line #949)
end;

TJSCellMouseOverEvent = class(TJSCellEvent)  // (Line #952)
end;

TJSCellMouseOutEvent = class(TJSCellEvent)  // (Line #954)
end;

TJSCellContextMenuEvent = class(TJSCellEvent)  // (Line #956)
end;

TJSCellEditingStartedEvent = class(TJSCellEvent)  // (Line #958)
end;

TJSCellEditingStoppedEvent = class(TJSCellEvent)  // (Line #961)
  OldValue : TJSValue {$IFDEF PAS2JS} external name 'oldValue' {$ENDIF}; (* Union Type(3): TValue | null | undefined *)
  NewValue : TJSValue {$IFDEF PAS2JS} external name 'newValue' {$ENDIF}; (* Union Type(3): TValue | null | undefined *)
  ValueChanged : Boolean {$IFDEF PAS2JS} external name 'valueChanged' {$ENDIF};
end;

TJSCellValueChangedEvent = class(TJSCellWithDataEvent)  // (Line #971)
  OldValue : TJSValue {$IFDEF PAS2JS} external name 'oldValue' {$ENDIF}; (* Union Type(3): TValue | null | undefined *)
  NewValue : TJSValue {$IFDEF PAS2JS} external name 'newValue' {$ENDIF}; (* Union Type(3): TValue | null | undefined *)
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(2): string | undefined *)
end;

TJSCellEditRequestEvent = class(TJSCellWithDataEvent)  // (Line #978)
  OldValue : TJSValue {$IFDEF PAS2JS} external name 'oldValue' {$ENDIF}; (* Union Type(3): TValue | null | undefined *)
  NewValue : TJSValue {$IFDEF PAS2JS} external name 'newValue' {$ENDIF}; (* Union Type(3): TValue | null | undefined *)
  Source : TJSValue {$IFDEF PAS2JS} external name 'source' {$ENDIF}; (* Union Type(2): string | undefined *)
end;

TJSAsyncTransactionsFlushedEvent = class(TJSAgGlobalEvent)  // (Line #985)
  Results : TJSValue (* Unknown Type *) {$IFDEF PAS2JS} external name 'results' {$ENDIF};
end;

TJSAsyncTransactionsFlushed = class(TJSAsyncTransactionsFlushedEvent)  // (deprecated) (Line #994)
end;

TJSStoreRefreshedEvent = class(TJSAgGlobalEvent)  // (deprecated) (Line #997)
  Route : TJSValue {$IFDEF PAS2JS} external name 'route' {$ENDIF}; (* array of string *)
end;

TJSStateUpdatedEvent = class(TJSAgGlobalEvent)  // (Line #1003)
  Sources : TJSValue {$IFDEF PAS2JS} external name 'sources' {$ENDIF}; (* Union Type(2): array of keyof | array of 'gridInitializing' *)
  State : TJSGridState {$IFDEF PAS2JS} external name 'state' {$ENDIF};
end;

TJSScrollVisibilityChangedEvent = class(TJSAgGlobalEvent)  // (Line #1010)
end;

TJSStoreUpdatedEvent = class(TJSAgGlobalEvent)  // (Line #1013)
end;

TJSLeftPinnedWidthChangedEvent = class(TJSAgGlobalEvent)  // (Line #1016)
end;

TJSRightPinnedWidthChangedEvent = class(TJSAgGlobalEvent)  // (Line #1018)
end;

TJSRowContainerHeightChanged = class(TJSAgGlobalEvent)  // (Line #1021)
end;

TJSFlashCellsEvent = class(TJSAgGlobalEvent)  // (Line #1029)
  Cells : TJSValue {$IFDEF PAS2JS} external name 'cells' {$ENDIF};
end;

TJSDisplayedRowsChangedEvent = class(TJSAgGlobalEvent)  // (Line #1032)
  AfterScroll : Boolean {$IFDEF PAS2JS} external name 'afterScroll' {$ENDIF};
end;

TJSCssVariablesChanged = class(TJSAgGlobalEvent)  // (Line #1037)
  ThemeChanged : TJSValue {$IFDEF PAS2JS} external name 'themeChanged' {$ENDIF}; (* boolean *)
  HeaderHeightChanged : TJSValue {$IFDEF PAS2JS} external name 'headerHeightChanged' {$ENDIF}; (* boolean *)
  RowHeightChanged : TJSValue {$IFDEF PAS2JS} external name 'rowHeightChanged' {$ENDIF}; (* boolean *)
  ListItemHeightChanged : TJSValue {$IFDEF PAS2JS} external name 'listItemHeightChanged' {$ENDIF}; (* boolean *)
end;

TJSAdvancedFilterEnabledChangedEvent = class(TJSAgGlobalEvent)  // (Line #1045)
  Enabled : Boolean {$IFDEF PAS2JS} external name 'enabled' {$ENDIF};
end;

TJSDataTypesInferredEvent = class(TJSAgGlobalEvent)  // (Line #1050)
end;

TJSFieldValueEvent = class(TJSAgGlobalEvent)  // (Line #1053)
  Value : TJSValue {$IFDEF PAS2JS} external name 'value' {$ENDIF};
end;

TJSFieldPickerValueSelectedEvent = class(TJSFieldValueEvent (* , TJSAgGlobalEvent *))  // (Line #1109)
  FromEnterKey : Boolean {$IFDEF PAS2JS} external name 'fromEnterKey' {$ENDIF};
end;

TJSRichSelectListRowSelectedEvent = class(TJSFieldValueEvent (* , TJSAgGlobalEvent *))  // (Line #1111)
  FromEnterKey : Boolean {$IFDEF PAS2JS} external name 'fromEnterKey' {$ENDIF};
end;

TJSAlignedGridColumnEvent = class(TJSAgGlobalEvent)  // (Line #1066)
  Event : TJSColumnEvent {$IFDEF PAS2JS} external name 'event' {$ENDIF};
end;

TJSAlignedGridScrollEvent = class(TJSAgGlobalEvent)  // (Line #1071)
  Event : TJSBodyScrollEvent {$IFDEF PAS2JS} external name 'event' {$ENDIF};
end;

TJSGridOptionsChangedEvent = class(TJSAgGlobalEvent)  // (Line #1076)
  Options : TJSGridOptions {$IFDEF PAS2JS} external name 'options' {$ENDIF};
end;

TJSScrollbarWidthChangedEvent = class(TJSAgGlobalEvent)  // (Line #1081)
end;

TJSKeyShortcutChangedCellStartEvent = class(TJSAgGlobalEvent)  // (Line #1083)
end;

TJSKeyShortcutChangedCellEndEvent = class(TJSAgGlobalEvent)  // (Line #1085)
end;

TJSHeightScaleChangedEvent = class(TJSAgGlobalEvent)  // (Line #1087)
end;

TJSSuppressMovableColumnsEvent = class(TJSAgGlobalEvent)  // (Line #1089)
end;

TJSSuppressMenuHideEvent = class(TJSAgGlobalEvent)  // (Line #1091)
end;

TJSSuppressFieldDotNotationEvent = class(TJSAgGlobalEvent)  // (Line #1093)
end;

TJSColumnContainerWidthChangedEvent = class(TJSAgGlobalEvent)  // (Line #1095)
end;

TJSRowContainerHeightChangedEvent = class(TJSAgGlobalEvent)  // (Line #1097)
end;

TJSHeaderHeightChangedEvent = class(TJSAgGlobalEvent)  // (Line #1099)
end;

TJSColumnHeaderHeightChangedEvent = class(TJSAgGlobalEvent)  // (Line #1101)
end;

TJSGridStylesChangedEvent = class(TJSAgGlobalEvent)  // (Line #1103)
end;

TJSRowCountReadyEvent = class(TJSAgGlobalEvent)  // (Line #1105)
end;

TJSFieldValueChangedEvent = class(TJSAgGlobalEvent)  // (Line #1107)
end;

TJSSideBarUpdatedEvent = class(TJSAgGlobalEvent)  // (Line #1113)
end;

TJSChartTitleEditEvent = class(TJSAgGlobalEvent)  // (Line #1115)
end;

TJSRecalculateRowBoundsEvent = class(TJSAgGlobalEvent)  // (Line #1117)
end;

{$ENDREGION}
{$ENDREGION}

  TJSAgGrid = class {$IFDEF PAS2JS}external name '__agGrid__'{$ENDIF} (TJSObject)
  public

    class function createGrid(GridElement: TJSElement; GridOptions: TJSObject) : TJSAgGrid; overload;{$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure _destroy {$ifdef PAS2JS} external name 'destroy' {$endif}; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}

    function getGridOption(OptionName: String):TJSValue; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure setGridOption(OptionName: String; Value: TJSValue); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getDataAsCsv(): string; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure exportDataAsCsv(); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getSelectedNodes(): TJSRowNodes; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getFocusedCell(): TJSFocusedCell; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getRowNode(RowId: TJSValue): TJSRowNode; overload; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getRowNode(RowId: String): TJSRowNode; overload; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getDisplayedRowAtIndex(RowIndex: Integer): TJSRowNode; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getCellValue(Param: TJSGetCellValueParams): String; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure setNodesSelected(Value: TJSValue); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure refreshCells(Value: TJSValue); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure deselectAll(); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function applyTransaction(rowDataTransaction: TJSObject): TJSRowNodeTransaction; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}

    procedure startEditingCell(Params: TJSObject); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure stopEditing(cancel: Boolean = False); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getEditingCells: TJSCellPositions; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure ensureIndexVisible(index: Integer); overload; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure ensureIndexVisible(index: Integer; position: String); overload; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function paginationGetPageSize: Integer; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function paginationGetCurrentPage: Integer; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure paginationGoToPage(index: Integer); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function paginationGetRowCount: Integer; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getDisplayedRowCount: Integer; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getColumnState: TJSColumnStates; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure applyColumnState(Value: TJSApplyColumnStateParams); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getFilterModel: TJSValue; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure setFilterModel(Value: TJSValue); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure purgeInfiniteCache; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure refreshInfiniteCache; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure setRowCount(RowCount: Integer); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getLastDisplayedRowIndex: Integer; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getInfiniteRowCount: Integer; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure hideOverlay; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure resetRowHeights; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    function getColumnDefs: TJSArray; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure addEventListener(EventType: string; EventListener: Pointer); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure removeEventListener(EventType: string; EventListener: Pointer); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure resetColumnState; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
  end;

  TJSAgGridLocale = class {$IFDEF PAS2JS}external name '__agGridLocale__'{$ENDIF} (TJSObject)
  public
    AG_GRID_LOCALE_BG: TJSObject;
    AG_GRID_LOCALE_BR: TJSObject;
    AG_GRID_LOCALE_CN: TJSObject;
    AG_GRID_LOCALE_CZ: TJSObject;
    AG_GRID_LOCALE_DE: TJSObject;
    AG_GRID_LOCALE_DK: TJSObject;
    AG_GRID_LOCALE_EG: TJSObject;
    AG_GRID_LOCALE_EN: TJSObject;
    AG_GRID_LOCALE_ES: TJSObject;
    AG_GRID_LOCALE_FI: TJSObject;
    AG_GRID_LOCALE_FR: TJSObject;
    AG_GRID_LOCALE_GR: TJSObject;
    AG_GRID_LOCALE_HK: TJSObject;
    AG_GRID_LOCALE_HR: TJSObject;
    AG_GRID_LOCALE_HU: TJSObject;
    AG_GRID_LOCALE_IL: TJSObject;
    AG_GRID_LOCALE_IR: TJSObject;
    AG_GRID_LOCALE_IT: TJSObject;
    AG_GRID_LOCALE_JP: TJSObject;
    AG_GRID_LOCALE_KR: TJSObject;
    AG_GRID_LOCALE_NL: TJSObject;
    AG_GRID_LOCALE_NO: TJSObject;
    AG_GRID_LOCALE_PK: TJSObject;
    AG_GRID_LOCALE_PL: TJSObject;
    AG_GRID_LOCALE_PT: TJSObject;
    AG_GRID_LOCALE_RO: TJSObject;
    AG_GRID_LOCALE_SE: TJSObject;
    AG_GRID_LOCALE_SK: TJSObject;
    AG_GRID_LOCALE_TR: TJSObject;
    AG_GRID_LOCALE_TW: TJSObject;
    AG_GRID_LOCALE_UA: TJSObject;
    AG_GRID_LOCALE_VN: TJSObject;
  end;

  function getAgGridApi(InDesigner: Boolean = False; ApiName: String = 'agGrid') : Pointer;

implementation


{ TJSAgGrid }

function getAgGridApi(InDesigner: Boolean = False; ApiName: String = 'agGrid'): Pointer;
begin
  Result := nil;
{$IFDEF PAS2JS}
asm
  var theDoc = document;
  if (InDesigner) {
    let ele = document.getElementById("projecthtml");
    if (typeof(ele) == "object" && typeof(ele.ownerDocument) == "object") {
      theDoc = ele.ownerDocument;
    }
  }

  if (typeof(exports) === 'object' && typeof(module) === 'object' && typeof(module.exports) != "undefined") {
    Result = module.exports;
  } else if (typeof(define) === 'function' && define.amd) {
    if (typeof(theDoc[ApiName]) !== 'object') {
      console.error("Error: Unable to find document."+ApiName+" reference!\r\n"
        +"Please ensure that the AG-Grid JS file can be found and loaded\r\n"
        +"in manner similar to the following:\r\n"
        +"<script type=\"text/javascript\">\r\n"
        +"require([\"js/ag-grid-community\"], function("+ApiName+") {\r\n"
        +"  document."+ApiName+" = "+ApiName+";\r\n"
        +"  rtl.run();\r\n"
        +"});\r\n"
        +"</script>");
    }
    Result = theDoc[ApiName];
  } else if (typeof(exports) === 'object') {
    Result = exports[ApiName];
  } else {
    Result = theDoc[ApiName];
  }
end;
{$ENDIF}
end;

{ TJSConvert }

class function TJSConvert.FieldToJSValue(Field: TField): TJSValue;
begin
  Result := nil;
  if Assigned(Field) then
  begin

    case Field.DataType of
      ftUnknown: ;
      ftString: Result := Field.AsString;
      ftInteger: Result := Field.AsInteger;
      ftLargeInt: Result := Field.AsInteger;
      ftBoolean: Result := Field.AsBoolean;
      ftFloat: Result := Field.AsFloat;
      ftDate: Result := Field.AsString;
      ftTime: Result := Field.AsString;
      ftDateTime: Result := Field.AsString;
      ftAutoInc: Result := Field.AsString;
      ftBlob: Result := Field.AsString;
      ftMemo: Result := Field.AsString;
      ftFixedChar: Result := Field.AsString;
      ftVariant: Result := Field.AsString;
      ftDataset: ;
      ftWideString: Result := Field.AsString;
      ftWord: Result := Field.AsInteger;
    end;
  end;

end;

class function TJSConvert.JSValueToField(Value: TJSValue; Field: TField): Boolean;
begin
  Result := False;
  if Assigned(Field) then
  begin
    case Field.DataType of
      ftUnknown: begin end;
      ftString:
        begin
          if Value = nil then
            Field.SetData({$IFNDEF PAS2JS}TValueBuffer(nil){$ELSE}nil{$ENDIF})
          else
            Field.AsString := String(Value);
          Result := True;
        end;
      ftInteger: begin Field.AsInteger := Integer(Value); Result := True; end;
      ftLargeInt: begin Field.AsLargeInt := Int64(Value); Result := True; end;
      ftBoolean:
        begin
          if Value = nil then
            Field.AsBoolean := False
          else
            Field.AsBoolean := Boolean(Value);
          Result := True;
        end;
      ftFloat: begin Field.AsFloat := Double(Value); Result := True; end;
      ftDate: begin Field.AsString := String(Value); Result := True; end;
      ftTime: begin Field.AsString := String(Value); Result := True; end;
      ftDateTime: begin Field.AsString := String(Value); Result := True; end;
      ftAutoInc: begin Field.AsString := String(Value); Result := True; end;
      ftBlob: begin end;
      ftMemo: begin Field.AsString := String(Value); Result := True; end;
      ftFixedChar: begin Field.AsString := String(Value); Result := True; end;
      ftVariant: begin Field.AsString := String(Value); Result := True; end;
      ftDataset: begin end;
      ftWideString: begin Field.AsString := String(Value); Result := True; end;
      ftWord: begin Field.AsInteger := Integer(Value); Result := True; end;
    end;
  end;
end;

{ TJSGetCellValueParams }

constructor TJSGetCellValueParams.Create(ARowNode: TJSRowNode; AColKey: String;
  AUseFormatter: Boolean);
begin
  RowNode := ARowNode;
  ColKey := AColKey;
  UseFormatter := AUseFormatter;
end;

end.
